export default __webpack_public_path__ + "8e854827131e806586778d551929d1b8.png";